<template>
  <v-row
    class="mb-2"
    no-gutters
    justify="space-between"
    align="center">
    <h2>
      {{ title }}
      <v-icon
        v-if="iconName"
        :color="iconColor"
        size="24">
        {{ iconName }}
      </v-icon>
    </h2>
    <p
      class="mb-0 fs-14 blue--text text-uppercase pointer"
      @click="switchView">
      {{ routeToTitle }}
    </p>
  </v-row>
</template>
<script>
export default {
  name: 'CollectionsSearchTitle',
  props: {
    titleIcon: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: null,
    },
    criteria: {
      type: String,
      default: null,
    },
  },
  computed: {
    queryCriteria() {
      return this.$route.query.criteria;
    },
    routeToTitle() {
      return this.queryCriteria ?
        'collapsed view' : 'see all';
    },
    iconColor() {
      const { color } = this.titleIcon ?? {
      };
      return color;
    },
    iconName() {
      const { name } = this.titleIcon ?? {
      };
      return name;
    },
  },
  methods: {
    switchView() {
      this.$router.push({
        ...this.$route,
        query: {
          ...this.$route.query,
          ...(this.queryCriteria ? {
            criteria: undefined,
          } : {
            criteria: this.criteria,
          }),
        },
      }).then(() => {
        this.$nextTick(() => {
          this.$emit('switchView');
        });
      });

    },
  },
};
</script>
